import {decorate, observable} from 'mobx';
import i18n from '../i18n/i18n';
import {BaseModel} from './base';
import {transformation} from '../utils/transformations';
import {InspectionTask} from './inspectionTask';
import {displayableProperty} from './displayableProperty';
import {sortChronologicallyIgnoreMilliseconds} from '../components/shared/tables/sorters';
import {InspectionTaskGroup} from './inspectionTaskGroup';

export class InspectionTaskPending extends BaseModel {
  displayableProperties = [
    displayableProperty({
      key: 'dueDate',
      params: [{path: 'dueDate', transform: transformation.none}],
      template: '{value}',
      title: i18n.t('inspectionTaskPending.model.attributes.dueDate'),
      raw: false,
    }),
  ];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.inspectionTask = rootStore.inspectionTaskStore.getById(this.inspectionTaskId);
    this.inspectionTaskGroup = rootStore.inspectionTaskGroupStore.getById(this.inspectionTask?.inspectionTaskGroupId);
    this.inspectionLot = rootStore.inspectionLotStore.getById(this.inspectionTask?.inspectionLotId);
  }

  static allDisplayableProperties(rootStore, pathPrefix = '', titlePrefix = '') {
    const allDisplayableProperties = super.allDisplayableProperties(rootStore, pathPrefix, titlePrefix);
    allDisplayableProperties.push(
      ...InspectionTask.allDisplayableProperties(rootStore, `${pathPrefix}inspectionTask.`, titlePrefix)
    );
    const inspectionTaskGroupPrefix = `${titlePrefix}${i18n.t('inspectionTaskGroup.model.one')} > `;
    allDisplayableProperties.push(
      ...InspectionTaskGroup.allDisplayableProperties(
        rootStore, `${pathPrefix}inspectionTaskGroup.`, inspectionTaskGroupPrefix
      )
    );

    return allDisplayableProperties;
  }

  static sort(a, b) {
    if (a.pausedSince && !b.pausedSince) {
      return 1;
    }
    if (!a.pausedSince && b.pausedSince) {
      return -1;
    }
    if (!a.dueDate && b.dueDate) {
      return 1;
    }
    if (a.dueDate && !b.dueDate) {
      return -1;
    }
    return sortChronologicallyIgnoreMilliseconds(a.dueDate, b.dueDate);
  }
}

decorate(InspectionTaskPending, {
  id: observable,
  inspectionTaskId: observable,
  inspectionTask: observable,
  inspectionTaskGroup: observable,
  inspectionLot: observable,
  dueDate: observable,
  pausedSince: observable,
  pausedByUserId: observable,
});
